import React, { useContext } from 'react';

import { I18nContext } from '../context/translations/TranslationsContext.context';
import { esApp } from './plataforma';

/** La política de privacidad pública. */
export const PRIVACY_POLICY_URL = 'https://arcadigital.app/privacidad';

/**
 * Enlace a la política de privacidad, en Configuración → Soporte.
 *
 * Apple exige que se pueda abrir desde dentro de la app (norma 5.1.1). Va aquí y no en el menú del
 * avatar, que es para moverse por la app (decidido el 15-oct-2026). Se abre en el navegador del
 * sistema, como Soporte.
 *
 * Solo en la app: en el navegador no pinta nada.
 */
const EnlacePrivacidad: React.FC = () => {
	const { translate } = useContext(I18nContext).state;

	if (!esApp()) {
		return null;
	}

	return (
		<a
			href={PRIVACY_POLICY_URL}
			target="_blank"
			rel="noopener noreferrer"
			className="mt-4 inline-block text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground"
		>
			{translate('user.settings.privacyPolicy')}
		</a>
	);
};

export default EnlacePrivacidad;
